import React, { useContext, useEffect, useState } from "react";
import "./search.scss";
import { searchQuestion } from "../../services/searchQuestion";
import { getAllSubject } from "../../services/getAllSubject";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import CommonForm from "../HomePage/Form/CommonForm";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import { CategoryContext } from "../../categoryContext";
import Librarybanner from "./Librarybanner";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import BonusSection from "../../Components/BonusSection";
import WorldWide from "../../Components/WorldWide";
import AskQue from "../../Components/AskQue";
import { Helmet } from "react-helmet";
import RecentlyAskedQue from "../../Components/RecentlyAskedQue";
const Library = () => {
  const [subjectId, setSubjectId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isDataFetching, setIsDataFetching] = useState(true);
  const navigate = useNavigate();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [serviceType, setServiceType] = useState("");



  const fetchData = async () => {
    try {
      const search = searchParams.get("query");
      const data = await searchQuestion(search, currentPage, 5, subjectId);
      setIsDataFetching(false);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSubjectData = async () => {
    try {
      const response = await getAllSubject();
      setFormData(response.data);
    } catch (error) {
      console.error("Error fetching subject data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    setIsDataFetching(true);
  }, [searchParams]);

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, subjectId]);

  useEffect(() => {
    fetchSubjectData();
  }, []);

 

  const { categoryId } = useContext(CategoryContext);
  const [isModelOpen1, setIsModelOpen1] = useState(false);
  const toggle = () => {
    setIsModelOpen1(!isModelOpen1);
    setIsModelOpen(!isModelOpen);
  };

  return (
    <>
      <Helmet>
        <title>
          Library | Get Personalized Academic Success with DoubtQ | Online
          Question Help
        </title>
        <meta name="description" content="Welcome to the Library of DoubtQ" />
        <meta property="og:title" content="Library - DoubtQ" />
        <meta
          property="og:description"
          content="Explore personalized academic help on DoubtQ's Library"
        />
      </Helmet>
      {/* <Nav />
      <Navbar /> */}
      <div className="row mt-2 mb-2 px-4 m-0">
        <div className="col-lg-12">
          <div className="breadcrumb-inner text-start">
            <ul className="page-list">
              <li className="rbt-breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li>
                <div className="icon-right">
                  <MdOutlineKeyboardArrowRight />
                </div>
              </li>
              <li className="rbt-breadcrumb-item active">Library</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mb-4 top-que-banner">
        <Librarybanner id={categoryId} setIsModelOpen={setIsModelOpen} />
      </div>
      <RecentlyAskedQue />
      <AskQue />
      <BonusSection subCategoryId={categoryId} />
      <WorldWide />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={serviceType}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default Library;
